import { useCallback, useEffect, useState } from 'react';
import { getHomeDashboard } from '../services/dashboard';
import { mapDashboardData } from '../utils/dashboardMappers';
import { publishAppToast } from '../utils/appToast';

export function useHomeDashboard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getHomeDashboard();
      setData(mapDashboardData(res?.data));
    } catch (e) {
      const message = e?.message || 'Failed to load dashboard';
      setError(message);
      setData(null);
      publishAppToast(message, 'error');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return { data, loading, error, refetch: fetchDashboard };
}
